import DotNetObject = DotNet.DotNetObject;
import { WebUserPermission, EditWebUserPermission } from '@crimsontide/core/client/interfaces';

export const WebUserPermissionService = (() => {
  let dotNetObj: DotNetObject;
  let cachedWebUserPermissions: WebUserPermission[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getByCurrentWebUser = async (): Promise<WebUserPermission> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<WebUserPermission>('GetByCurrentWebUserAsync');
    } else {
      throw 'WebUserPermissionService DotNet Object Reference has not yet been implemented';
    }
  };

  const getWebUserPermissions = async (useCache: boolean = true): Promise<WebUserPermission[]> => {
    if (useCache && cachedWebUserPermissions != null)
      return cachedWebUserPermissions;

    if (dotNetObj) {
      cachedWebUserPermissions = await dotNetObj.invokeMethodAsync<WebUserPermission[]>('GetAllAsync');
      return cachedWebUserPermissions;
    } else {
      throw 'WebUserPermissionService DotNet Object Reference has not yet been implemented';
    }
  };

  const editWebUserPermission = async (editWebUserPermission: EditWebUserPermission): Promise<object> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<object>('EditAsync', editWebUserPermission);
    } else {
      throw 'WebUserPermissionService DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getByCurrentWebUser,
    getWebUserPermissions,
    editWebUserPermission,
  };
})();
